import { render, staticRenderFns } from "./MainContentBg.vue?vue&type=template&id=4b809212&"
import script from "./MainContentBg.vue?vue&type=script&lang=js&"
export * from "./MainContentBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports